import { IMaintenanceRequestData } from '../../../../../models';

/**
 * @method getMaintenanceNameFromUrl
 * @description gets the Maintenance name from the url
 * @returns Maintenance name
 */
export const getMaintenanceNameFromUrl = (): string => {
  const { pathname } = window.location;
  const urlArray = pathname.split('/');
  try {
    if (urlArray && urlArray.length > 5) {
      return urlArray[urlArray.length - 1];
    }
  } catch (error) {
    return '';
  }
  return '';
};

/**
 * @method getModeFromUrl
 * @description gets the Maintenance mode from the url
 * @returns Maintenance mode(edit/view)
 */

export const getModeFromUrl = (): string => {
  const { pathname } = window.location;
  const urlArray = pathname.split('/');
  try {
    if (urlArray && urlArray.length > 0) {
      return urlArray[urlArray.length - 2];
    }
  } catch (error) {
    return '';
  }
  return '';
};

export const SCHEDULE_MAINTENANCE_ROUTE = {
  CREATE_SM_ROUTE: '/control-plane/configuration/schedule-maintenance/add',
  SCHEDULE_MAINTENANCE_HOME: '/control-plane/configuration/schedule-maintenance',
};

export const SCHEDULE_MAINTENANCE_MODE = {
  VIEW: 'View',
  EDIT: 'Edit',
  ADD: 'Add'
};

const nameSwitcher = (headerText: string, text: string) => `${headerText} ${text}`;
// function to return header title in SM
export const fetchHeaderTitle = (maintenanceName: string, maintenanceMode: string, headerTxt: string, supportingTextForAdd: string) => (
  `${(maintenanceMode.toUpperCase() !== SCHEDULE_MAINTENANCE_MODE.VIEW.toUpperCase() && maintenanceMode.toUpperCase() !== SCHEDULE_MAINTENANCE_MODE.EDIT.toUpperCase()) ? nameSwitcher(headerTxt, supportingTextForAdd) : ''}${maintenanceName}`);

export const setImpactedServices = (isEdit: boolean, selArray: any[], payloadData: IMaintenanceRequestData) => {
  const dataPayload = payloadData;
  if (isEdit) {
    dataPayload.isEdit = true;
  }
  if (selArray?.length > 0) {
    dataPayload.impactedServices = selArray.map((service) => ({
      serviceName: service.serviceName,
      serviceVersion: service.serviceVersion,
    }));
    return dataPayload;
  }
  return payloadData;
};

export const setSelectedServices = (selArray: any[], services: any, deleteDataItem: any) => {
  if (selArray?.length > 0) {
    const index = services.findIndex((x: any) => x === deleteDataItem);
    if (index >= 0) {
      services[index].isChecked = false;
    }
    selArray = selArray.filter((x) => x !== deleteDataItem);
  }
  return {
    selArray,
    services
  };
};
